import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { navLinks, brand } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
      scrolled ? "bg-white/85 backdrop-blur-md border-b border-[#E5E5E5] shadow-[0_2px_18px_-12px_rgba(115,16,13,0.18)]" : "bg-transparent"
    }`}>
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-3 group">
          <div className="relative w-13 h-13 rounded-xl bg-white grid place-items-center overflow-hidden border-2 border-[#73100D]/30 shadow-[0_2px_14px_-4px_rgba(115,16,13,0.28)] group-hover:border-[#73100D]/60 transition-all duration-300" style={{width:"52px",height:"52px"}}>
            <img src={brand.logo} alt="RSP Innovations" className="w-11 h-11 object-contain transition-transform duration-500 group-hover:scale-110" />
          </div>
          <div className="leading-tight">
            <div className="text-[17px] font-bold tracking-tight text-[#111]">
              RSP <span className="text-[#73100D]">Innovations</span>
            </div>
            <div className="text-[9px] uppercase tracking-[0.18em] text-[#888]">RSPInnov LLP · Right Solution Path</div>
          </div>
        </a>

        <ul className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <li key={l.name}>
              <a href={l.href}
                className="text-sm font-medium text-[#333] hover:text-[#73100D] transition-colors duration-200 relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#73100D] hover:after:w-full after:transition-all after:duration-300">
                {l.name}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden lg:block">
          <a href="#contact" className="btn-primary inline-flex items-center rounded-full font-semibold px-6 h-10 text-sm">
            <span>Book a Call</span>
          </a>
        </div>

        <button className="lg:hidden text-[#333]" onClick={() => setOpen((v) => !v)} aria-label="Toggle menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-white/95 backdrop-blur border-t border-[#E5E5E5]">
          <ul className="flex flex-col py-4 px-6 gap-3">
            {navLinks.map((l) => (
              <li key={l.name}>
                <a onClick={() => setOpen(false)} href={l.href} className="block py-2 text-[#333] hover:text-[#73100D]">{l.name}</a>
              </li>
            ))}
            <li>
              <a href="#contact" onClick={() => setOpen(false)} className="block py-2 text-[#73100D] font-semibold">
                Book a Call →
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
